export const validationOptions = {
  validateOnBlur: true,
  validateOnModelUpdate: false,
};

export const options = {
  accreditationBody: [
    { value: 'eaccme', label: 'European CME credits' },
    { value: 'accme', label: '<i>AMA PRA Category 1 Credits™</i> (US or outside Europe)' },
  ],
  yesOrNo: [
    'No',
    'Yes',
  ],
  userIsDoctorOfMedicine: [
    { value: false, label: 'No' },
    { value: true, label: 'Yes' },
  ],
};

/**
 *  1. Quality of the ELM
 */
export const UsefulnessOptions = [
  'Undecided',
  'Not useful',
  'Fairly useful',
  'Useful',
  'Extremely useful',
];

export const UsefulnessOptionsValuesMapping = {
  [UsefulnessOptions[0]]: 'undecided',
  [UsefulnessOptions[1]]: 'not_useful',
  [UsefulnessOptions[2]]: 'fairly_useful',
  [UsefulnessOptions[3]]: 'useful',
  [UsefulnessOptions[4]]: 'extremely_useful',
};

export const OverallImpressionOptions = [
  'Very poor',
  'Poor',
  'Fairly good',
  'Good',
  'Excellent',
];

export const OverallImpressionOptionsValuesMapping = {
  [OverallImpressionOptions[0]]: 'very_poor',
  [OverallImpressionOptions[1]]: 'poor',
  [OverallImpressionOptions[2]]: 'fairly_good',
  [OverallImpressionOptions[3]]: 'good',
  [OverallImpressionOptions[4]]: 'excellent',
};

/**
 *  2. Relevance of Material
 */
export const EducationalGoalsAndScientificEvidenceOptions = [
  'Undecided',
  'Not at all',
  'Not much',
  'Somewhat',
  'Very much',
];

export const EducationalGoalsAndScientificEvidenceOptionsValuesMapping = {
  [EducationalGoalsAndScientificEvidenceOptions[0]]: 'undecided',
  [EducationalGoalsAndScientificEvidenceOptions[1]]: 'not_at_all',
  [EducationalGoalsAndScientificEvidenceOptions[2]]: 'not_much',
  [EducationalGoalsAndScientificEvidenceOptions[3]]: 'somewhat',
  [EducationalGoalsAndScientificEvidenceOptions[4]]: 'very_much',
};

/**
 * 3. Suitability of formats used during the material
 */
export const LearnerEngagementTimeOptions = [
  'Undecided',
  'Never',
  'Only rarely',
  'Yes, sometimes',
  'Yes, always or almost always',
];

export const LearnerEngagementTimeOptionsValuesMapping = {
  [LearnerEngagementTimeOptions[0]]: 'undecided',
  [LearnerEngagementTimeOptions[1]]: 'never',
  [LearnerEngagementTimeOptions[2]]: 'only_rarely',
  [LearnerEngagementTimeOptions[3]]: 'yes_sometimes',
  [LearnerEngagementTimeOptions[4]]: 'yes_always_or_almost_always',
};

/**
 *  4 Ways the material affects clinical practice
 */
export const InformationImplementationOptions = [
  'Undecided',
  'Not at all',
  'Not much',
  'Somewhat',
  'Very much',
];

export const InformationImplementationOptionsValuesMapping = {
  [InformationImplementationOptions[0]]: 'undecided',
  [InformationImplementationOptions[1]]: 'not_at_all',
  [InformationImplementationOptions[2]]: 'not_much',
  [InformationImplementationOptions[3]]: 'somewhat',
  [InformationImplementationOptions[4]]: 'very_much',
};

export const FacultyConflictDeclarationOptions = [
  'Undecided',
  'No',
  'Yes, but only a small part',
  'Yes, for the majority',
  'Yes, all',
];

export const FacultyConflictDeclarationOptionsValuesMapping = {
  [FacultyConflictDeclarationOptions[0]]: 'undecided',
  [FacultyConflictDeclarationOptions[1]]: 'no',
  [FacultyConflictDeclarationOptions[2]]: 'yes_but_only_small_part',
  [FacultyConflictDeclarationOptions[3]]: 'yes_for_majority',
  [FacultyConflictDeclarationOptions[4]]: 'yes_all',
};

export const InformationFreeOfBiasOptions = [
  'Undecided',
  'Strongly disagree',
  'Rather disagree',
  'Rather agree',
  'Strongly agree',
];

export const InformationFreeOfBiasOptionsValuesMapping = {
  [InformationFreeOfBiasOptions[0]]: 'undecided',
  [InformationFreeOfBiasOptions[1]]: 'strongly_disagree',
  [InformationFreeOfBiasOptions[2]]: 'rather_disagree',
  [InformationFreeOfBiasOptions[3]]: 'rather_agree',
  [InformationFreeOfBiasOptions[4]]: 'strongly_agree',
};